import List from './List'
import Detail from './Detail'

const StaffPick = () => ({
  path: '/staff-pick',
  children: [List(), Detail()],
})

export default StaffPick
